import { render, staticRenderFns } from "./_stockholders.vue?vue&type=template&id=74009e33&scoped=true&"
import script from "./_stockholders.vue?vue&type=script&lang=js&"
export * from "./_stockholders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74009e33",
  null
  
)

export default component.exports